import { initContract } from "@ts-rest/core";
import { z } from "zod";

import {
  cesSurveySchema,
  cesSurveyTriggerPointEnumSchema,
  updateCesSurveySchema,
} from "@libs/db-schemas";

import { HTTPStatusCode } from "../../types";
import { errorSchema } from "../../utils/errors";

const c = initContract();

export const cesSurveysContract = c.router({
  requestCesSurvey: {
    summary:
      "Create a CES survey for the patient when they are one of the few sampled at this trigger point",
    method: "POST",
    path: "/ces-surveys",
    body: z.object({
      triggerPoint: cesSurveyTriggerPointEnumSchema,
    }),
    responses: {
      [HTTPStatusCode.CREATED]: cesSurveySchema,
      // The patient was not sampled, or has already been surveyed
      [HTTPStatusCode.OK]: z.object({ isSelected: z.literal(false) }),
      [HTTPStatusCode.BAD_REQUEST]: errorSchema,
      [HTTPStatusCode.UNAUTHORIZED]: errorSchema,
    },
  },
  submitCesSurveyResponse: {
    summary: "Record the patient's answer to their CES survey",
    method: "PATCH",
    path: "/ces-surveys/:id",
    pathParams: z.object({
      id: z.uuid(),
    }),
    body: updateCesSurveySchema,
    responses: {
      [HTTPStatusCode.OK]: cesSurveySchema,
      [HTTPStatusCode.BAD_REQUEST]: errorSchema,
      [HTTPStatusCode.UNAUTHORIZED]: errorSchema,
      [HTTPStatusCode.FORBIDDEN]: errorSchema,
      [HTTPStatusCode.NOT_FOUND]: errorSchema,
    },
  },
});
